import { render, staticRenderFns } from "./AlignItems.vue?vue&type=template&id=2741c7fd&"
import script from "./AlignItems.vue?vue&type=script&lang=js&"
export * from "./AlignItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports